module.exports = __webpack_public_path__ + "img/Employees_blue.f8947b5d.svg";